import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AppStateService} from "../providers/app-state.service";
import {environment} from "../../environments/environment";
import {VMessageDgSearchResults} from "../models/datagrid-search-results/v-message.dg-search-results.model";
import {VMessageService} from "../providers/v-message.service";

@Injectable()
export class VMessagesResolve implements Resolve<VMessageDgSearchResults> {
  constructor(private vMessageService: VMessageService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<VMessageDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    let map = new Map<string, string>();
    map.set('isReceivedFromUser', 'false');
    return this.vMessageService.searchForResults(environment.DEFAULT_RESULTS_LIMIT, 0, map, 'DESC', 'created', false).pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
